<script>
    import { handleAsync } from "../common/safe_promise";
    import Form from "./form/Form.svelte";
    import Modal from "./Modal.svelte";
    import { fade } from "svelte/transition";
    import { _ } from "svelte-i18n";
    import { createEventDispatcher } from "svelte";
    import LanguageSelect from "./LanguageSelect.svelte";
    import { notifySuccess } from "../stores/notifications";

    export let doc = null;
    export let form;
    export let valid = false;
    export let deletable = true;
    let locale = "en";

    if (!doc) {
        doc = {};
    }
    let data = doc;
    $: isNew = doc && !doc._exists;

    const handleSubmit = handleAsync(async () => {
        dispatch("save", { data, isNew });

        notifySuccess($_("Form.DocumentSaved"));
        isNew = false;
    });

    const dispatch = createEventDispatcher();

    const handleDelete = handleAsync(async () => {
        showDelete = false;
        dispatch("delete");

        notifySuccess($_("Form.DocumentDeleted"));
    });

    let showDelete = false;

    $: localizable = form.fields.some(({ localizable }) => localizable);
</script>

{#if showDelete}
    <div transition:fade>
        <Modal class="flex flex-col p-4" bind:opened={showDelete}>
            <h1 class="text-4xl">{$_('AreYouSure')}</h1>
            <span class="text-xl py-8">{$_('AreYouSureYouWantToDoThis')}</span>
            <div class="flex justify-between mt-8">
                <button
                    class="px-8 py-4"
                    on:click={() => (showDelete = false)}>{$_('No')}</button>
                <button
                    class="px-8 py-4 bg-red-500"
                    on:click={handleDelete}>{$_('Yes')}</button>
            </div>
        </Modal>
    </div>
{/if}

<Form bind:values={data} {form} on:submit={handleSubmit} bind:valid {locale}>
    <div slot="header" class="w-full">
        <slot name="header">
            <div class="w-full flex justify-between">
                <div>
                    {#if localizable}
                        <LanguageSelect bind:value={locale} />
                    {/if}
                </div>
                <div class="flex space-x-4">
                    {#if isNew}
                        <button
                            type="submit"
                            disabled={!valid}>{$_('Form.Save')}</button>
                    {:else}
                        {#if deletable}
                            <button
                                type="button"
                                on:click={() => (showDelete = true)}
                                class="bg-red-500">{$_('Form.Delete')}</button>
                        {/if}
                        <button
                            type="submit"
                            disabled={!valid}>{$_('Form.Update')}</button>
                    {/if}
                </div>
            </div>
        </slot>
    </div>
    <div slot="footer" class="w-full">
        <slot name="footer" />
    </div>
</Form>
